import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class VicariaService {
  async getVicariasAll() {
    return await fetchWrapper.get(`${ruta}/vicarias`);
  }

  async filtrarCurias(datos) {
    return await fetchWrapper.post(`${ruta}/vicarias/filtrar_curias`, datos);
  }

  async imprimirPDF(datos) {
    return await fetchWrapper.postPdf(`${ruta}/vicarias/reporte_derecho_curia`, datos);
  }
}
